import { render, staticRenderFns } from "./AddClientAccount.vue?vue&type=template&id=587dcd40&scoped=true"
import script from "./AddClientAccount.vue?vue&type=script&lang=js"
export * from "./AddClientAccount.vue?vue&type=script&lang=js"
import style0 from "./AddClientAccount.vue?vue&type=style&index=0&id=587dcd40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587dcd40",
  null
  
)

export default component.exports